module.exports = __webpack_public_path__ + "02_bob_brown.555f20b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/02_bob_brown.png
// module id = TpK1
// module chunks = 0